import React from 'react';
import request from '../../../request';
import Input from '../../shared/labelInput';

export default class EditCompany extends React.Component {
  constructor() {
    super();
    this.state = { company: {} };
  }

  async componentDidMount() {
    let { match } = this.props;

    try {
      this.setState({ loading: true });
      let company = await request({
        url: `admin/companies/${match.params.id}`,
      });
      localStorage.setItem('company', JSON.stringify(company));
      this.setState({ company, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  async save() {
    let { match } = this.props;

    try {
      this.setState({ loading: true });
      let company = await request({
        url: `admin/companies/${match.params.id}`,
        method: 'PATCH',
        body: this.state.company,
      });

      this.setState({ company, loading: false, error: null });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false, error: e.message || e });
    }
  }

  render() {
    let { company, loading, error } = this.state;

    return (
      <div id="dashboard" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Edit</h5>
        {error ? <p className="error">{error}</p> : null}
        <Input
          name="name"
          label="Company Name"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.name || ''}
        />

        <Input
          id="email_field"
          name="email"
          label="Email"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.email || ''}
        />

        <Input
          name="phone_extension"
          label="Phone Ext"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.phone_extension || ''}
        />

        <Input
          name="phone"
          label="Phone"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.phone || ''}
        />

        <Input
          name="fax"
          label="Fax"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.fax || ''}
        />

        <Input
          name="address"
          label="Address"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.address || ''}
        />

        <Input
          name="address_2"
          label="Address Line 2"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.address_2 || ''}
        />

        <Input
          name="city"
          label="City"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.city || ''}
        />

        <Input
          name="state"
          label="State"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.state || ''}
        />

        <Input
          type="number"
          name="zip"
          label="Zip"
          onChange={e => this.setState({
            company: { ...company, [e.target.name]: e.target.value },
          })}
          value={company.zip || ''}
        />

        <div className="options">
          <button
            className="control_button"
            id="save"
            type="submit"
            onClick={() => this.save()}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/companies/edit.js